<template>
  <div>
    <v-row class="grey darken-4 mx-0">
      <v-col cols="6" md="3" lg="2">
        <c-select
          rotulo="Opções de busca"
          itemText="label"
          itemValue="value"
          :clearable="false"
          :lista="options"
          :item.sync="searchFields.option"
        />
      </v-col>
      <template
        v-if="searchFields.option ? searchFields.option.value == 'tipo' : false"
      >
        <v-col cols="6" md="3" lg="3">
          <c-select
            rotulo="Tipo"
            :lista="accountTypeList"
            :item.sync="searchFields.text"
          />
        </v-col>
      </template>
      <template v-else>
        <v-col cols="6" md="3" lg="3">
          <v-text-field
            class="text-caption"
            label="Termo da busca"
            :placeholder="searchFields.option.label"
            :maxlength="searchFields.option.maxLength"
            outlined
            dense
            dark
            v-model="searchFields.text"
          />
        </v-col>
      </template>
    </v-row>
    <c-index-buttons @search="sendSearch()" @register="openRegister()" @changeHeader="changeHeaderDialog = !changeHeaderDialog" />
    <v-row>
      <v-col cols="12">
        <megabit-table
          :table-header="tableHeaderSelected"
          :table-items="accountList"
          :loading="loadingItems"
          :doDelete="doDelete"
          columnMasked="CLASSIFICACAO"
          selectable
          @item-selected="selectItem($event)"
          route="plano-contas.register"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="d-inline-flex">
        <v-pagination
          class="ml-auto"
          v-model="query.page"
          :total-visible="pagination.per_page"
          :length="pagination.last_page"
          :disabled="loadingItems"
          @input="sendSearch()"
        />
      </v-col>
    </v-row>
    <router-view />
    <change-header 
      v-model="tableHeaderAvaiable" 
      :showDialog="changeHeaderDialog" 
      @close="changeHeaderDialog = !changeHeaderDialog"
      :name="headerName" />
  </div>
</template>

<script>
import MegabitTable from "@/components/shared/table/MegabitTable";
import { tableMixin } from "@/mixins/component/table/TableMixin";
import { headerMixin } from "@/mixins/component/table/HeaderMixin";
import cSelect from "@/components/shared/base-input/BaseSelect.vue";
import cIndexButtons from "@/components/shared/base-buttons/IndexButtons";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  components: { MegabitTable, cSelect, cIndexButtons },
  mixins: [tableMixin, headerMixin],
  data: () => ({
    headerName: 'accountIndex',
    options: [
      { label: "Código", value: "codigo", maxLength: 30},
      { label: "Nome", value: "nome", maxLength:40 },
      { label: "Classificação", value: "classificacao", maxLength:12 },
      { label: "Tipo", value: "tipo" },
    ],
    searchFields: {
      option: {},
    },
    query: {
      codigo: "",
      nome: "",
      classificacao: "",
      page: 1,
    },
    tableHeaderAvaiable: [
        { text: "Nome", value: "NOME", align: "start" , show:true},
        { text: "Código", value: "CODIGO", width: 100 , show:true},
        { text: "Classificação", value: "CLASSIFICACAO" , show:true},
        { text: "Tipo", value: "TIPO" , show:true},
        { text: "Ações", value: "controls", align: "right" , show:true},
      ]
  }),
  computed: {
    ...mapGetters({
      accountTypeList: "accountsModule/getAccountTypeList",
    }),

    ...mapState("accountsModule", [
      "loadingItems",
      "pagination",
      "accountList",
    ]),
  },
  async created() {
    await this.fetch();
    this.mountHeader();
  },
  methods: {
    ...mapActions("accountsModule", [
      "getAccounts",
      "mixAccountTypes",
      "deleteAccount",
    ]),
    async fetch() {
      try {
        await this.mixAccountTypes();
        await this.getAccounts(this.query);
        this.searchFields.option = this.options[0];
      } catch (error) {
        this.$toasted.error(error, { duration: null });
      }
    },

    async doDelete(item) {
      try {
        const response = await this.deleteAccount(item.CODIGO);
        this.$toasted.success(response);
      } catch (error) {
        this.$toasted.error(error, { duration: null });
      }
    },

    openRegister() {
      if (!this.selectedItem) {
        this.$toasted.error("Marque um Plano de Contas para continuar.");
        return;
      }
      let classificacao = this.selectedItem.CLASSIFICACAO
        ? this.selectedItem.CLASSIFICACAO
        : 1;
      this.$router.push({
        name: "plano-contas.register",
        params: { classificacao },
      });
    },

    async sendSearch() {
      let searchText = this.searchFields.text ?? "";

      if (!this.searchFields.option) {
        this.$toasted.error("Selecione uma opção de busca");
        return;
      }

      try {
        let key = this.searchFields.option.value;

        if (searchText.trim().length > 0) {
          this.query[key] = searchText;
        }

        await this.getAccounts(this.query);
        this.cleanSearch();
      } catch (error) {
        this.$toasted.error(error, {duration: null});
      }
    },
    cleanSearch() {
      Object.keys(this.query).forEach((key) => {
        if (key !== "page" && key !== "todos") this.query[key] = "";
      });
    },
  },
};
</script>

<style></style>
